/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { LinearProgress } from '@mui/material'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

/** 전체 화면 로딩 — 키커 한 줄 + 2px 진행선. 그라운드는 페이지 색 그대로 */
export const Spinner = (): JSX.Element => {
	return (
		<View css={style} role="status" aria-live="polite">
			<View className="loadingView">
				<span className="loadingLabel">Loading</span>
				<LinearProgress className="loadingProgress" />
			</View>
		</View>
	)
}

const style = css({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	height: '100vh',
	overflow: 'hidden',
	background: mono.bg,
	fontFamily: boFont.ui,

	'.loadingView': {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		width: 240,
	},
	'.loadingLabel': {
		fontSize: 11,
		letterSpacing: '.3em',
		textTransform: 'uppercase',
		fontWeight: 500,
		color: mono.faint,
	},
	'.loadingProgress': {
		height: 2,
		backgroundColor: mono.line,
		'.MuiLinearProgress-bar': { backgroundColor: mono.ink },
	},
})
